import React from 'react';
import styled from 'styled-components';
import { Button, H1, H4 } from 'components';
import { NeedHelpLink } from 'components/VerificationForm/styles';
import { theme, toRem } from 'design';
import ErrorImage from './ErrorImage';

interface IErrorScreenProps {
  title?: string;
  message?: string;
  buttonLabel?: string;
  to?: string;
  includeHelp?: boolean;
}

const Layout = styled.div`
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`;

const Content = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(33)};
  justify-items: center;
  width: 100%;
  padding: 0 ${toRem(theme.layout.gutter.large)};
`;

const Messaging = styled.section`
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Message = styled(H4)`
  color: ${theme.color.neutral[700]};
`;

const ErrorScreen: React.FC<IErrorScreenProps> = ({ title = 'Oh no! Something went wrong!', message, buttonLabel = 'Take Me Back', to = '/', includeHelp }) => (
  <Layout data-cy="app-error">
    <ErrorImage />
    <Content>
      <Messaging>
        <H1>{title}</H1>
        {message && <Message>{message}</Message>}
      </Messaging>
      <Button label={buttonLabel} appearance="primary" size="large" to={to} />
      {includeHelp && <NeedHelpLink>Need some help?</NeedHelpLink>}
    </Content>
  </Layout>
);

export default ErrorScreen;
